import React from "react";
import { IconProps } from "./types";

function IconUploadCloud(props: IconProps) {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="upload-cloud-01">
        <path
          id="Vector"
          d="M5.66659 23.0098C3.95811 21.8662 2.83325 19.9186 2.83325 17.7083C2.83325 14.3883 5.37122 11.661 8.61289 11.3608C9.27599 7.32719 12.7786 4.25 16.9999 4.25C21.2212 4.25 24.7238 7.32719 25.3869 11.3608C28.6286 11.661 31.1666 14.3883 31.1666 17.7083C31.1666 19.9186 30.0417 21.8662 28.3333 23.0098M11.3333 22.6667L16.9999 17M16.9999 17L22.6666 22.6667M16.9999 17V29.75"
          stroke="#64748B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export default IconUploadCloud;
